
export { default as always } from "./always.js"
export { default as anyPass } from "./anyPass.js"
export { default as compose } from "./compose.js"
export { default as defaultTo } from "./defaultTo.js"
export { default as has } from "./has.js"
export { default as identity } from "./identity.js"
export { default as ifElse } from "./ifElse.js"
export { default as propOr } from "./propOr.js"
export { default as tryCatch } from "./tryCatch.js"